export class PTWFilter {
  Units: number[] = [];
  PageSize: number = 0;
  PageIndex: number = 50;
  OrderdByColoumName: string;
  OrderdBy: string;
  SearchText: string;
  FromDate: Date = null;
  ToDate: Date = null;
  PermitType: number[] = [];
  Locations: number[] = [];
  StatusId: number[] = [];
  SelectAll: boolean;
  CurrentPage: number;
  UserId: number;
}
